import { Leaf } from "lucide-react";

const ITEMS = [
  "ISO 9001 Certified Manufacturing",
  "100% Recyclable & Biodegradable",
  "Global Multimodal Freight",
  "Custom Private Label OEM",
  "Zero Plastic Footprint Goals",
  "Tested & Compliant",
];

/**
 * One slow editorial ribbon — sage band drifting beneath the hero.
 */
export default function Marquee() {
  return (
    <section
      aria-label="Trust indicators"
      data-testid="trust-marquee"
      className="marquee-pause relative overflow-hidden bg-sage border-y border-line py-4"
    >
      <div className="marquee-track flex w-max items-center">
        {[...ITEMS, ...ITEMS].map((t, i) => (
          <span
            key={i}
            className="flex items-center gap-10 pr-10 text-[11px] sm:text-xs uppercase tracking-[0.3em] font-semibold text-forest whitespace-nowrap"
          >
            {t}
            <Leaf className="h-3.5 w-3.5 text-brand" strokeWidth={2} />
          </span>
        ))}
      </div>
    </section>
  );
}
